import { ref, onMounted, onUnmounted } from 'vue';

/**
 * Tracks Ctrl/Cmd and Shift modifier key state via global window listeners.
 * Registers on mount and cleans up on unmount.
 *
 * @returns {{ isCtrlPressed: Ref<boolean>, isShiftPressed: Ref<boolean> }}
 */
export function useKeyboardModifiers() {
  const isCtrlPressed = ref(false);
  const isShiftPressed = ref(false);

  function handleKeyDown(event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey) {
      isCtrlPressed.value = true;
    }
    if (event.shiftKey) {
      isShiftPressed.value = true;
    }
  }

  function handleKeyUp(event: KeyboardEvent) {
    if (!event.ctrlKey && !event.metaKey) {
      isCtrlPressed.value = false;
    }
    if (!event.shiftKey) {
      isShiftPressed.value = false;
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
  });

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyDown);
    window.removeEventListener('keyup', handleKeyUp);
  });

  return {
    isCtrlPressed,
    isShiftPressed
  };
}
